import { ref } from 'vue'

const cslStyles = ref<string[]>([])
export default () => {
  async function set(styles: string[]) {
    cslStyles.value = styles
  }
  return { set, list: cslStyles }
}
